module.exports = __webpack_public_path__ + "static/media/workshop_cart.40fd8c71.svg";